function canonicalServiceUrl(serviceId) {
    return serviceId.endsWith('info.json')
        ? serviceId
        : serviceId.endsWith('/')
            ? `${serviceId}info.json`
            : `${serviceId}/info.json`;
}

function extractFixedSizeScales(width, height, sizes) {
    const len = sizes.length;
    const scales = [];
    for (let i = 0; i < len; i++) {
        const size = sizes[i];
        const w = size.width;
        scales.push(width / w);
    }
    return scales;
}

function fixedSizesFromScales(width, height, scales) {
    const len = scales.length;
    const sizes = [];
    for (let i = 0; i < len; i++) {
        const scale = scales[i];
        sizes.push({
            width: Math.floor(width / scale),
            height: Math.floor(height / scale),
        });
    }
    return sizes;
}

const STANFORD_IIIF_IMAGE_COMPLIANCE_0 = 'http://library.stanford.edu/iiif/image-api/compliance.html#level0';
const STANFORD_IIIF_IMAGE_COMPLIANCE_1 = 'http://library.stanford.edu/iiif/image-api/compliance.html#level1';
const STANFORD_IIIF_IMAGE_COMPLIANCE_2 = 'http://library.stanford.edu/iiif/image-api/compliance.html#level2';
const STANFORD_IIIF_IMAGE_CONFORMANCE_0 = 'http://library.stanford.edu/iiif/image-api/conformance.html#level0';
const STANFORD_IIIF_IMAGE_CONFORMANCE_1 = 'http://library.stanford.edu/iiif/image-api/conformance.html#level1';
const STANFORD_IIIF_IMAGE_CONFORMANCE_2 = 'http://library.stanford.edu/iiif/image-api/conformance.html#level2';
const STANFORD_IIIF_1_IMAGE_COMPLIANCE_0 = 'http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0';
const STANFORD_IIIF_1_IMAGE_COMPLIANCE_1 = 'http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1';
const STANFORD_IIIF_1_IMAGE_COMPLIANCE_2 = 'http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2';
const STANFORD_IIIF_1_IMAGE_CONFORMANCE_0 = 'http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0';
const STANFORD_IIIF_1_IMAGE_CONFORMANCE_1 = 'http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1';
const STANFORD_IIIF_1_IMAGE_CONFORMANCE_2 = 'http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2';
const IIIF_1_IMAGE_LEVEL_0 = 'http://iiif.io/api/image/1/level0.json';
const IIIF_1_IMAGE_LEVEL_0_PROFILE = 'http://iiif.io/api/image/1/profiles/level0.json';
const IIIF_1_IMAGE_LEVEL_1 = 'http://iiif.io/api/image/1/level1.json';
const IIIF_1_IMAGE_LEVEL_1_PROFILE = 'http://iiif.io/api/image/1/profiles/level1.json';
const IIIF_1_IMAGE_LEVEL_2 = 'http://iiif.io/api/image/1/level2.json';
const IIIF_1_IMAGE_LEVEL_2_PROFILE = 'http://iiif.io/api/image/1/profiles/level2.json';
const IIIF_2_IMAGE_LEVEL_0 = 'http://iiif.io/api/image/2/level0.json';
const IIIF_2_IMAGE_LEVEL_0_PROFILE = 'http://iiif.io/api/image/2/profiles/level0.json';
const IIIF_2_IMAGE_LEVEL_1 = 'http://iiif.io/api/image/2/level1.json';
const IIIF_2_IMAGE_LEVEL_1_PROFILE = 'http://iiif.io/api/image/2/profiles/level1.json';
const IIIF_2_IMAGE_LEVEL_2 = 'http://iiif.io/api/image/2/level2.json';
const IIIF_2_IMAGE_LEVEL_2_PROFILE = 'http://iiif.io/api/image/2/profiles/level2.json';
const IIIF_3_IMAGE_LEVEL_0 = 'level0';
const IIIF_3_IMAGE_LEVEL_1 = 'level1';
const IIIF_3_IMAGE_LEVEL_2 = 'level2';
const IIIF_2_IMAGE_LEVEL_0_NO_JSON = 'http://iiif.io/api/image/2/level0';
const IIIF_2_IMAGE_LEVEL_1_NO_JSON = 'http://iiif.io/api/image/2/level1';
const IIIF_2_IMAGE_LEVEL_2_NO_JSON = 'http://iiif.io/api/image/2/level2';
const level1Support = [
    IIIF_2_IMAGE_LEVEL_1_NO_JSON,
    IIIF_2_IMAGE_LEVEL_2_NO_JSON,
    STANFORD_IIIF_IMAGE_COMPLIANCE_1,
    STANFORD_IIIF_IMAGE_COMPLIANCE_2,
    STANFORD_IIIF_IMAGE_CONFORMANCE_1,
    STANFORD_IIIF_IMAGE_CONFORMANCE_2,
    STANFORD_IIIF_1_IMAGE_COMPLIANCE_1,
    STANFORD_IIIF_1_IMAGE_COMPLIANCE_2,
    STANFORD_IIIF_1_IMAGE_CONFORMANCE_1,
    STANFORD_IIIF_1_IMAGE_CONFORMANCE_2,
    IIIF_1_IMAGE_LEVEL_1,
    IIIF_1_IMAGE_LEVEL_1_PROFILE,
    IIIF_1_IMAGE_LEVEL_2,
    IIIF_1_IMAGE_LEVEL_2_PROFILE,
    IIIF_2_IMAGE_LEVEL_1,
    IIIF_2_IMAGE_LEVEL_1_PROFILE,
    IIIF_2_IMAGE_LEVEL_2,
    IIIF_2_IMAGE_LEVEL_2_PROFILE,
    IIIF_3_IMAGE_LEVEL_1,
    IIIF_3_IMAGE_LEVEL_2,
];
const imageServiceProfiles = [
    IIIF_2_IMAGE_LEVEL_0_NO_JSON,
    IIIF_2_IMAGE_LEVEL_1_NO_JSON,
    IIIF_2_IMAGE_LEVEL_2_NO_JSON,
    STANFORD_IIIF_IMAGE_COMPLIANCE_0,
    STANFORD_IIIF_IMAGE_COMPLIANCE_1,
    STANFORD_IIIF_IMAGE_COMPLIANCE_2,
    STANFORD_IIIF_IMAGE_CONFORMANCE_0,
    STANFORD_IIIF_IMAGE_CONFORMANCE_1,
    STANFORD_IIIF_IMAGE_CONFORMANCE_2,
    STANFORD_IIIF_1_IMAGE_COMPLIANCE_0,
    STANFORD_IIIF_1_IMAGE_COMPLIANCE_1,
    STANFORD_IIIF_1_IMAGE_COMPLIANCE_2,
    STANFORD_IIIF_1_IMAGE_CONFORMANCE_0,
    STANFORD_IIIF_1_IMAGE_CONFORMANCE_1,
    STANFORD_IIIF_1_IMAGE_CONFORMANCE_2,
    IIIF_1_IMAGE_LEVEL_0,
    IIIF_1_IMAGE_LEVEL_0_PROFILE,
    IIIF_1_IMAGE_LEVEL_1,
    IIIF_1_IMAGE_LEVEL_1_PROFILE,
    IIIF_1_IMAGE_LEVEL_2,
    IIIF_1_IMAGE_LEVEL_2_PROFILE,
    IIIF_2_IMAGE_LEVEL_0,
    IIIF_2_IMAGE_LEVEL_0_PROFILE,
    IIIF_2_IMAGE_LEVEL_1,
    IIIF_2_IMAGE_LEVEL_1_PROFILE,
    IIIF_2_IMAGE_LEVEL_2,
    IIIF_2_IMAGE_LEVEL_2_PROFILE,
    IIIF_3_IMAGE_LEVEL_0,
    IIIF_3_IMAGE_LEVEL_1,
    IIIF_3_IMAGE_LEVEL_2,
];

function getId(resource) {
    if (resource['@id']) {
        return resource['@id'];
    }
    if (resource.id) {
        return resource.id;
    }
    return undefined;
}

function isImageService(service) {
    if (!service || !service.profile) {
        return false;
    }
    if (!getId(service)) {
        return false;
    }
    const profiles = Array.isArray(service.profile)
        ? service.profile
        : [service.profile];
    for (const profile of profiles) {
        if (typeof profile === 'string' &&
            imageServiceProfiles.indexOf(profile) !== -1) {
            return true;
        }
    }
    return false;
}

function supportsCustomSizes(service) {
    if (!isImageService(service)) {
        return false;
    }
    const profiles = Array.isArray(service.profile)
        ? service.profile
        : [service.profile];
    for (const profile of profiles) {
        if (typeof profile === 'string') {
            if (level1Support.indexOf(profile) !== -1) {
                return true;
            }
        }
        else {
            const supports = profile.supports || [];
            if (supports.indexOf('regionByPx') !== -1 &&
                (supports.indexOf('sizeByW') !== -1 ||
                    supports.indexOf('sizeByWh') !== -1)) {
                return true;
            }
        }
    }
    return false;
}

function getCustomSizeFromService(service) {
    if (!supportsCustomSizes(service)) {
        return [];
    }
    const imagesSizes = [];
    const profiles = Array.isArray(service.profile)
        ? service.profile
        : [service.profile];
    const pLen = profiles.length;
    for (let x = 0; x < pLen; x++) {
        const profile = profiles[x];
        if (typeof profile !== 'string') {
            if (profile.maxHeight || profile.maxWidth) {
                return [
                    {
                        id: getId(service),
                        type: 'variable',
                        minWidth: 0,
                        minHeight: 0,
                        maxHeight: (profile.maxHeight || profile.maxWidth),
                        maxWidth: (profile.maxWidth || profile.maxHeight),
                    },
                ];
            }
        }
    }
    if (service.tiles) {
        const len = service.tiles.length;
        for (let y = 0; y < len; y++) {
            const tile = service.tiles[y];
            if (tile.height || tile.width) {
                imagesSizes.push({
                    id: getId(service),
                    type: 'variable',
                    minHeight: 0,
                    minWidth: 0,
                    maxHeight: tile.height || tile.width,
                    maxWidth: tile.width,
                });
            }
        }
    }
    return imagesSizes;
}

function inferSizeFromUrl(image) {
    const regex = /^.*\/(full)\/(((\d+),(\d+)?)|max)\/(\d+)\/default\.(jpg|png|jpeg)$/;
    const match = image.match(regex);
    if (match) {
        const region = match[1];
        const width = parseInt(match[4], 10);
        const height = parseInt(match[5], 10);
        const format = match[7];
        if ((region === 'max' || region === 'full') && width && height && format) {
            return {
                type: 'fixed',
                id: image,
                height,
                width,
            };
        }
    }
    return { type: 'unknown', id: image };
}

function getType(resource) {
    if (resource['@type']) {
        return resource['@type'];
    }
    if (resource.type) {
        return resource.type;
    }
    return undefined;
}

function getFixedSizeFromImage(contentResource) {
    if (typeof contentResource === 'string') {
        return inferSizeFromUrl(contentResource);
    }
    const type = getType(contentResource);
    if (type !== 'Image' && type !== 'sc:Image') {
        return null;
    }
    const image = contentResource;
    const id = getId(image);
    if (!id) {
        return null;
    }
    if (id && image.width && image.height) {
        return {
            id: id,
            type: 'fixed',
            width: image.width,
            height: image.height,
            unsafe: true,
        };
    }
    return inferSizeFromUrl(id);
}

function getFixedSizesFromService(service) {
    if (!isImageService(service)) {
        return [];
    }
    return (service && service.sizes ? service.sizes : []).map((size) => {
        return {
            id: getId(service),
            type: 'fixed-service',
            height: size.height,
            width: size.width,
        };
    });
}

function getImageCandidatesFromService(service) {
    const candidates = [];
    const totalServices = service.length;
    for (let s = 0; s < totalServices; s++) {
        const fixedSizes = getFixedSizesFromService(service[s]);
        if (fixedSizes.length) {
            candidates.push(...fixedSizes);
        }
        const customSizes = getCustomSizeFromService(service[s]);
        if (customSizes.length) {
            candidates.push(...customSizes);
        }
    }
    return candidates;
}

function getImageServices(resource) {
    const services = resource.service
        ? Array.isArray(resource.service)
            ? resource.service
            : [resource.service]
        : [];
    const totalServices = services.length;
    const imageServices = [];
    for (let i = 0; i < totalServices; i++) {
        if (isImageService(services[i]) &&
            resource.width &&
            resource.height) {
            imageServices.push(services[i]);
        }
    }
    return imageServices;
}

function getImageCandidates(unknownResource, dereference = true, loader) {
    const candidates = [];
    const fixedSizeFromImage = getFixedSizeFromImage(unknownResource);
    if (fixedSizeFromImage === null) {
        return candidates;
    }
    const resource = unknownResource;
    candidates.push(fixedSizeFromImage);
    if (dereference && resource.width && resource.height) {
        const refCandidates = [];
        const imageServices = getImageServices(resource);
        for (const service of imageServices) {
            const request = {
                id: getId(service),
                width: resource.width,
                height: resource.height,
            };
            if (loader.canLoadSync(request)) {
                const externalService = loader.loadServiceSync(request);
                if (externalService) {
                    if (!externalService.height) {
                        externalService.height = resource.height;
                    }
                    if (!externalService.width) {
                        externalService.width = resource.width;
                    }
                    refCandidates.push(...getImageCandidatesFromService([externalService]));
                }
            }
        }
        if (refCandidates.length) {
            candidates.push(...refCandidates);
            return candidates;
        }
    }
    if (resource.service) {
        candidates.push(...getImageCandidatesFromService(resource.service));
    }
    return candidates;
}

function getImageFromTileSource(image, targetWidth, targetHeight) {
    const id = canonicalServiceUrl(getId(image)).slice(0, -10);
    const url = [
        id,
        'full',
        [targetWidth, targetHeight || ''].join(','),
        0,
        'default.jpg',
    ].join('/');
    return {
        id: url,
        type: 'fixed',
        width: targetWidth,
        height: targetHeight || (image.height / image.width) * targetWidth,
        unsafe: image.width > targetWidth,
    };
}

function getImageServerFromId(url) {
    const id = url.replace(/(https?:\/\/)?(www.)?/i, '');
    if (id.indexOf('/') !== -1) {
        return id.split('/')[0];
    }
    return id;
}

function getSmallestScaleFactorAsSingleImage(service) {
    if (!service.width || !service.height) {
        return null;
    }
    if (service.tiles) {
        const tiles = service.tiles.sort((a, b) => {
            return Math.max(...b.scaleFactors) - Math.max(...a.scaleFactors);
        });
        const len = tiles.length;
        for (let i = 0; i < len; i++) {
            const tile = tiles[i];
            const targetSize = tile.width;
            if (!targetSize) {
                continue;
            }
            const sizeLen = tile.scaleFactors.length;
            const sortedScales = tile.scaleFactors.sort();
            for (let j = 0; j < sizeLen; j++) {
                const size = sortedScales[j];
                if (service.width / size <= targetSize &&
                    service.height / size <= targetSize) {
                    return {
                        id: getId(service),
                        type: 'fixed-service',
                        width: (service.width / size) | 0,
                        height: (service.height / size) | 0,
                    };
                }
            }
        }
    }
    return null;
}

function isBestMatch(request, current, candidate) {
    const width = !request.width ? request.maxWidth : request.width;
    return (candidate.height <= request.maxHeight &&
        candidate.width <= request.maxWidth &&
        candidate.height >= request.minHeight &&
        candidate.width >= request.minWidth &&
        (!current ||
            Math.abs(candidate.width - width) < Math.abs(current.width - width)));
}

function pickBestFromCandidates(inputRequest, candidates) {
    const log = [];
    const request = Object.assign({
        unsafeImageService: false,
        atAnyCost: true,
        fallback: true,
        minHeight: 20,
        minWidth: 20,
        maxHeight: Infinity,
        maxWidth: Infinity,
        returnAllOptions: false,
        preferFixedSize: false,
        allowUnsafe: false,
        explain: false,
        height: 0,
        width: 0,
    }, inputRequest);
    const lastResorts = [];
    const fallback = [];
    let currentChoice = null;
    const swapChoice = (candidate, current) => {
        if (isBestMatch(request, current, candidate)) {
            if (request.preferFixedSize && candidate.unsafe) {
                fallback.push(candidate);
                return;
            }
            if (request.returnAllOptions && current) {
                fallback.push(current);
            }
            currentChoice = candidate;
        }
        else if (request.returnAllOptions) {
            fallback.push(candidate);
        }
    };
    const candidateGroups = candidates.length;
    for (let x = 0; x < candidateGroups; x++) {
        const group = candidates[x]();
        const candidatesLength = group.length;
        for (let y = 0; y < candidatesLength; y++) {
            const candidate = group[y];
            if (candidate.type === 'unknown' && request.atAnyCost) {
                lastResorts.push(candidate);
            }
            if (candidate.type === 'fixed') {
                if (candidate.unsafe) {
                    lastResorts.push(candidate);
                }
                else {
                    swapChoice(candidate, currentChoice);
                }
            }
            if (candidate.type === 'fixed-service') {
                if (request.unsafeImageService) {
                    const choice = getImageFromTileSource(candidate, request.width, request.height);
                    swapChoice(choice, currentChoice);
                }
                else {
                    const choice = getImageFromTileSource(candidate, candidate.width, candidate.height);
                    swapChoice(choice, currentChoice);
                }
            }
            if (candidate.type === 'variable') {
                if (candidate.maxWidth) {
                    const choice = getImageFromTileSource({
                        id: candidate.id,
                        type: 'fixed-service',
                        width: candidate.maxWidth,
                        height: candidate.maxWidth,
                    }, candidate.maxWidth);
                    swapChoice(choice, currentChoice);
                }
            }
        }
        if (currentChoice && !request.returnAllOptions) {
            if (currentChoice.unsafe || request.allowUnsafe) {
                continue;
            }
            break;
        }
    }
    if (request.atAnyCost && fallback.length === 0) {
        return {
            best: currentChoice || lastResorts[0],
            fallback: lastResorts.slice(1),
            log,
        };
    }
    if (request.returnAllOptions) {
        return {
            best: request.atAnyCost
                ? currentChoice || fallback[0] || lastResorts[0]
                : currentChoice || fallback[0],
            fallback: [...fallback, ...lastResorts],
            log,
        };
    }
    return {
        best: currentChoice || fallback[0] || null,
        fallback: currentChoice ? fallback : fallback.slice(1),
        log,
    };
}

function sampledTilesToTiles(width, height, sampledTiles) {
    const maxDim = width > height ? width : height;
    const len = sampledTiles.length;
    const newTiles = [];
    for (let i = 0; i < len; i++) {
        const tile = sampledTiles[i];
        let lastSize = tile.scaleFactors[0];
        let curWidth = maxDim / lastSize;
        const scaleFactors = [lastSize];
        while (curWidth >= tile.width) {
            lastSize = lastSize * 2;
            scaleFactors.push(lastSize);
            curWidth = curWidth / 2;
        }
        newTiles.push(Object.assign(Object.assign({}, tile), { scaleFactors }));
    }
    return newTiles;
}

function sizesMatch(sizesA, sizesB) {
    if (sizesA.length !== sizesB.length) {
        return false;
    }
    if (sizesA.length === 0 && sizesB.length === 0) {
        return true;
    }
    const len = sizesA.length;
    let matchOrder = true;
    for (let i = 0; i < len; i++) {
        const a = sizesA[i];
        const b = sizesB[i];
        if (a.width !== b.width || a.height !== b.height) {
            matchOrder = false;
            break;
        }
    }
    if (matchOrder) {
        return true;
    }
    let matching = 0;
    for (let a = 0; a < len; a++) {
        for (let b = 0; b < len; b++) {
            if (sizesA[a].width === sizesB[b].width &&
                sizesA[a].height === sizesB[b].height) {
                matching++;
                break;
            }
        }
    }
    return matching === len;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

class ImageServiceLoader {
    constructor() {
        this.config = {
            verificationsRequired: 1,
            approximateServices: true,
            enableFetching: true,
            disableThrottling: false,
        };
        this.fetchingCount = 0;
        this.imageServices = {};
        this.knownImageServers = {};
    }
    setConfig(config) {
        Object.assign(this.config, config);
    }
    sample(service, preLoaded = true) {
        const server = getImageServerFromId(getId(service));
        const serviceUrl = canonicalServiceUrl(getId(service));
        const existing = this.knownImageServers[server];
        this.imageServices[serviceUrl] = Object.assign(service, { real: true });
        if (existing) {
            return this.verify(service);
        }
        this.knownImageServers[server] = {
            verifications: 0,
            malformed: false,
            root: server,
            preLoaded,
            sampledId: getId(service),
            verified: false,
            server: null,
            result: {
                context: service['@context'] || [],
                sampledProfile: service.profile,
                sampledSizes: service.sizes || [],
                sizeRatios: extractFixedSizeScales(service.width, service.height, service.sizes || []),
                sampledTiles: service.tiles || [],
            },
        };
        return true;
    }
    preLoad(server, forceVerify = true) {
        this.knownImageServers[server.root] = server;
        if (forceVerify) {
            this.knownImageServers[server.root].malformed = false;
            this.knownImageServers[server.root].verifications = this.config.verificationsRequired;
        }
    }
    predict(resource, verify = false, force = false) {
        const serverId = getImageServerFromId(getId(resource));
        const imageServer = this.knownImageServers[serverId];
        if (!imageServer ||
            !imageServer.result ||
            (!force &&
                (imageServer.malformed ||
                    imageServer.verifications < this.config.verificationsRequired))) {
            return null;
        }
        const serviceUrl = canonicalServiceUrl(getId(resource));
        if (!this.imageServices[serviceUrl]) {
            this.imageServices[serviceUrl] = {
                '@context': imageServer.result.context,
                '@id': getId(resource),
                id: getId(resource),
                protocol: 'http://iiif.io/api/image',
                tiles: sampledTilesToTiles(resource.width, resource.height, imageServer.result.sampledTiles),
                sizes: fixedSizesFromScales(resource.width, resource.height, imageServer.result.sizeRatios),
                profile: imageServer.result.sampledProfile,
                height: resource.height,
                width: resource.width,
                real: false,
            };
        }
        return this.imageServices[serviceUrl];
    }
    getThumbnailFromResource(unknownResource, request, dereference = true, otherCandidates = []) {
        return __awaiter(this, void 0, void 0, function* () {
            const candidates = yield this.getImageCandidates(unknownResource, dereference);
            return pickBestFromCandidates(request, [
                () => otherCandidates,
                () => candidates,
            ]);
        });
    }
    getImageCandidates(unknownResource, dereference = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const resource = unknownResource;
            if (dereference && resource.height && resource.width) {
                const imageServices = getImageServices(resource);
                for (const service of imageServices) {
                    const request = {
                        id: getId(service),
                        width: resource.width,
                        height: resource.height,
                    };
                    yield this.loadService(request);
                }
            }
            return getImageCandidates(unknownResource, dereference, this);
        });
    }
    verify(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            const prediction = this.predict(resource, false, true);
            const imageService = yield this.fetchService(getId(resource));
            if (!prediction) {
                return false;
            }
            const isValid = prediction.height === imageService.height &&
                prediction.width === imageService.width &&
                prediction['@context'] === imageService['@context'] &&
                sizesMatch(prediction.sizes || [], imageService.sizes || []);
            if (isValid) {
                const serverId = getImageServerFromId(getId(resource));
                this.knownImageServers[serverId].verifications += 1;
                if (this.knownImageServers[serverId].verifications >=
                    this.config.verificationsRequired) {
                    this.knownImageServers[serverId].verified = true;
                }
            }
            return isValid;
        });
    }
    canLoadSync(service) {
        const serviceId = typeof service === 'string' ? service : getId(service);
        const canonical = canonicalServiceUrl(serviceId);
        if (this.imageServices[canonical]) {
            return true;
        }
        const server = this.knownImageServers[getImageServerFromId(serviceId)];
        return (server &&
            !server.malformed &&
            server.verifications >= this.config.verificationsRequired);
    }
    markAsMalformed(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            this.knownImageServers[getImageServerFromId(getId(resource))].malformed = true;
            return this.loadService(resource, true);
        });
    }
    fetchService(serviceId, forceFresh = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const serviceUrl = canonicalServiceUrl(serviceId);
            if (this.imageServices[serviceUrl] &&
                (!forceFresh || this.imageServices[serviceUrl].real)) {
                return this.imageServices[serviceUrl];
            }
            if (!this.config.enableFetching) {
                throw new Error('Fetching is not enabled');
            }
            const json = (yield fetch(serviceUrl).then(service => service.json()));
            if (!json.id && json['@id']) {
                json.id = json['@id'];
            }
            if (json.id !== serviceId) {
                json.id = serviceId;
                if (json['@id']) {
                    json['@id'] = serviceId;
                }
            }
            this.imageServices[serviceUrl] = Object.assign(json, { real: true });
            return this.imageServices[serviceUrl];
        });
    }
    loadService(resource, forceFresh = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.config.disableThrottling) {
                while (true) {
                    if (this.fetchingCount >= this.config.verificationsRequired) {
                        yield new Promise((resolve) => setTimeout(resolve, 500));
                    }
                    else {
                        break;
                    }
                }
            }
            const imageServer = this.knownImageServers[getImageServerFromId(getId(resource))];
            if (imageServer && !imageServer.malformed && !forceFresh) {
                yield imageServer.result;
                const service = this.loadServiceSync(resource);
                if (service) {
                    return service;
                }
            }
            this.fetchingCount++;
            const serviceJson = yield this.fetchService(getId(resource), forceFresh);
            this.fetchingCount--;
            if (serviceJson.real) {
                this.sample(serviceJson);
            }
            return serviceJson;
        });
    }
    loadServiceSync(resource) {
        const serviceId = canonicalServiceUrl(getId(resource));
        if (this.imageServices[serviceId]) {
            return this.imageServices[serviceId];
        }
        return this.predict(resource);
    }
}
const imageServiceLoader = new ImageServiceLoader();

export { IIIF_1_IMAGE_LEVEL_0, IIIF_1_IMAGE_LEVEL_0_PROFILE, IIIF_1_IMAGE_LEVEL_1, IIIF_1_IMAGE_LEVEL_1_PROFILE, IIIF_1_IMAGE_LEVEL_2, IIIF_1_IMAGE_LEVEL_2_PROFILE, IIIF_2_IMAGE_LEVEL_0, IIIF_2_IMAGE_LEVEL_0_NO_JSON, IIIF_2_IMAGE_LEVEL_0_PROFILE, IIIF_2_IMAGE_LEVEL_1, IIIF_2_IMAGE_LEVEL_1_NO_JSON, IIIF_2_IMAGE_LEVEL_1_PROFILE, IIIF_2_IMAGE_LEVEL_2, IIIF_2_IMAGE_LEVEL_2_NO_JSON, IIIF_2_IMAGE_LEVEL_2_PROFILE, IIIF_3_IMAGE_LEVEL_0, IIIF_3_IMAGE_LEVEL_1, IIIF_3_IMAGE_LEVEL_2, ImageServiceLoader, STANFORD_IIIF_1_IMAGE_COMPLIANCE_0, STANFORD_IIIF_1_IMAGE_COMPLIANCE_1, STANFORD_IIIF_1_IMAGE_COMPLIANCE_2, STANFORD_IIIF_1_IMAGE_CONFORMANCE_0, STANFORD_IIIF_1_IMAGE_CONFORMANCE_1, STANFORD_IIIF_1_IMAGE_CONFORMANCE_2, STANFORD_IIIF_IMAGE_COMPLIANCE_0, STANFORD_IIIF_IMAGE_COMPLIANCE_1, STANFORD_IIIF_IMAGE_COMPLIANCE_2, STANFORD_IIIF_IMAGE_CONFORMANCE_0, STANFORD_IIIF_IMAGE_CONFORMANCE_1, STANFORD_IIIF_IMAGE_CONFORMANCE_2, canonicalServiceUrl, extractFixedSizeScales, fixedSizesFromScales, getCustomSizeFromService, getFixedSizeFromImage, getFixedSizesFromService, getImageCandidates, getImageCandidatesFromService, getImageFromTileSource, getImageServerFromId, getImageServices, getSmallestScaleFactorAsSingleImage, imageServiceLoader, imageServiceProfiles, inferSizeFromUrl, isBestMatch, isImageService, level1Support, pickBestFromCandidates, sampledTilesToTiles, sizesMatch, supportsCustomSizes };
//# sourceMappingURL=index.es.js.map
